// Channel names, topics, and IDs come from the customer's Slack workspace and
// are untrusted; render as text, never markup.

import { isNumber, isString } from "../utils/schemaUtils";

export interface SlackChannelItem {
  id: string;
  // Channel name without the leading '#'.
  name: string;
  isPrivate: boolean;
  topic?: string;
}

export interface SlackChannelsPayload {
  type: "slack_channels";
  query?: string;
  totalResults: number;
  channels: SlackChannelItem[];
}

const isSlackChannelItem = (v: unknown): v is SlackChannelItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.name) &&
    typeof r.isPrivate === "boolean" &&
    (r.topic === undefined || isString(r.topic))
  );
};

export const parseSlackChannelsPayload = (v: unknown): SlackChannelsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "slack_channels") return null;
  if (r.query !== undefined && !isString(r.query)) return null;
  if (!isNumber(r.totalResults)) return null;
  if (!Array.isArray(r.channels) || !r.channels.every(isSlackChannelItem)) return null;
  return {
    type: "slack_channels",
    query: r.query,
    totalResults: r.totalResults,
    channels: r.channels,
  };
};
